import {
  activeChatSideSelector,
  totalFilteredChatsBotSelector,
  totalFilteredChatsOnHoldSelector,
  totalFilteredChatsRequestSelector,
} from '@src/selectors/chats';
import { isFilteringInActiveSideSelector } from '@src/selectors/chatSearch';
import { ChatSideType } from '@src/types/chats';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { SearchIcon } from '../SvgIcons';

const AdvancedSearchResults = () => {
  const { formatMessage } = useIntl();
  const activeChatSide = useSelector(activeChatSideSelector);
  const isFiltering = useSelector(isFilteringInActiveSideSelector);

  const qtyFilteredChatsOnHold = useSelector(totalFilteredChatsOnHoldSelector);
  const qtyFilteredChatsRequest = useSelector(
    totalFilteredChatsRequestSelector
  );
  const qtyFilteredChatsBot = useSelector(totalFilteredChatsBotSelector);

  let qtyFilteredChats = 0;

  if (activeChatSide === ChatSideType.REQUEST)
    qtyFilteredChats = qtyFilteredChatsRequest;
  if (activeChatSide === ChatSideType.ON_HOLD)
    qtyFilteredChats = qtyFilteredChatsOnHold;
  if (activeChatSide === ChatSideType.BOT)
    qtyFilteredChats = qtyFilteredChatsBot;

  if (!isFiltering) return null;

  return (
    <div className="chat-search-results">
      {SearchIcon}
      {!qtyFilteredChats ? (
        <span style={{ fontWeight: 500 }}>
          {formatMessage({ id: 'Console.ChatSearch.NoResults.Message' })}
        </span>
      ) : (
        formatMessage(
          {
            id:
              qtyFilteredChats > 1
                ? 'Console.ChatSearch.QtyResults.Message'
                : 'Console.ChatSearch.OnceResult.Message',
          },
          {
            qty: (
              <strong style={{ margin: '0 3px ' }}>{qtyFilteredChats}</strong>
            ),
          }
        )
      )}
    </div>
  );
};

export default AdvancedSearchResults;
